import React from 'react';
import type { SiteSettings } from '@tsinternetsale/common';

export class SiteCustomizationClass {
    siteSettings: SiteSettings;

    constructor(siteSettings?: SiteSettings) {
        this.siteSettings = siteSettings;
    }
}

export const SiteCustomizationContext = React.createContext<SiteCustomizationClass>(new SiteCustomizationClass());
